import { Project, ProjectFormData, ProjectsResponse } from '@/types/project';
import { apiRequest } from './api';

const projectService = {
  // Obter lista de projetos de uma empresa
  async getAllByClient(
    companyId: string,
    search?: string,
    page?: number,
    limit?: number
  ): Promise<[ProjectsResponse | null, any]> {
    const params: any = {};
    if (search) params.search = search;
    if (page) params.page = page;
    if (limit) params.limit = limit;

    return apiRequest<ProjectsResponse>({
      loaderKey: 'projects',
      method: 'get',
      url: `/app/companies/${companyId}/projects`,
      params
    });
  },

  // Obter um projeto pelo ID
  async getById(companyId: string, projectId: string): Promise<[Project | null, any]> {
    const url = `/app/companies/${companyId}/projects/${projectId}`

    return apiRequest<Project>({
      loaderKey: 'project',
      method: 'get',
      url
    });
  },

  // Criar novo projeto
  async create(companyId: string, projectData: ProjectFormData): Promise<[any, any]> {
    return apiRequest({
      loaderKey: 'createProject',
      method: 'post',
      url: `/app/companies/${companyId}/projects`,
      data: projectData
    });
  },

  // Atualizar projeto existente
  async update(companyId: string, projectId: string, projectData: ProjectFormData): Promise<[any, any]> {
    return apiRequest({
      loaderKey: 'updateProject',
      method: 'put',
      url: `/app/companies/${companyId}/projects/${projectId}`,
      data: projectData
    });
  },

  // Obter todos os projetos da organização (sem filtrar por empresa) — usado no filtro de projeto dos tickets
  async getAll(search?: string, page?: number, limit?: number): Promise<[ProjectsResponse | null, any]> {
    const params: any = {};
    if (search) params.search = search;
    if (page) params.page = page;
    if (limit) params.limit = limit;

    return apiRequest<ProjectsResponse>({
      loaderKey: 'allProjects',
      method: 'get',
      url: `/app/projects`,
      params
    });
  },
};

export default projectService;
